import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'image',
  imports: [NgOptimizedImage],
  templateUrl: './image.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'relative flex shrink-0 z-10 overflow-hidden rounded-2xl',
    '[class.border-2]': 'showBorder()',
    '[class.border-accent-900]': 'showBorder()',
    '[class.image-with-shadow]': 'showBorder()'
  }
})
export class Image {
  url = input.required<string | ArrayBuffer>()
  alt = input<string>('')
  showBorder = input<boolean>(true)
  priority = input<boolean>(false)
}
